'use client';
import React from 'react';
import { Button, Link } from '@skin-seoul/design-system';

interface LoyaltySignUpBannerDesktopProps {
  titleLine2?: string;
}

export const LoyaltySignUpBannerDesktop = ({ titleLine2 = 'SkinSociety' }: LoyaltySignUpBannerDesktopProps) => {
  return (
    <div
      className="relative w-full h-[112px] rounded-[8px] overflow-hidden"
      style={{ background: 'linear-gradient(to top left, #311275, #754DCC)' }}
    >
      <div className="relative h-full flex items-center justify-between pl-4 pr-6 py-4 z-[1]">
        {/* Left Side - Title and Subtitle */}
        <div className="flex flex-col gap-2">
          <div className="flex flex-col gap-0">
            <span className="text-primary-100 text-heading-h6 font-bold">Join {titleLine2}</span>
            <span className="text-primary-100 text-heading-h6 font-bold">& Start Earning</span>
          </div>
          <p className="text-primary-100 text-label-small">Sign up to earn rewards</p>
        </div>

        {/* Right Side - Sign Up Button */}
        <Button
          className="h-[44px] bg-white text-neutral-800 px-6 hover:bg-neutral-50"
          asChild
          size="md"
          variant="primary"
        >
          <Link href="/login/">Sign Up</Link>
        </Button>
      </div>
    </div>
  );
};
